
export const publicRoutes = ['/forgot-password', '/reset-password'];
